export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ERROR = '/error';
export const MENU = '/menu';
export const TABLES = '/tables';